import type { PatientListItemType } from '../../../providers/patient/PatientsListProvider';
import { isOnHold, REQUIRED_ACTION_APPROVE_CASE } from '../../../utils/constants';
import { ApprovalCreditPill } from '../ApprovalCreditPill';

interface TreatmentStatusCellProps {
    patient: PatientListItemType;
}

export function TreatmentStatusCell({ patient }: TreatmentStatusCellProps) {
    return (
        <div className="flex flex-col gap-1 min-w-0">
            <span
                className={`block truncate${isOnHold(patient.treatmentStatus) ? ' text-red-600 font-bold' : ''}`}
            >
                {patient.treatmentStatus}
            </span>
            {patient.requiredAction === REQUIRED_ACTION_APPROVE_CASE && (
                <ApprovalCreditPill expiresAt={patient.approvalCreditExpiresAt ?? null} />
            )}
        </div>
    );
}
